import Plyr from 'plyr';
const Cookies = require('js-cookie');
import loadcss from 'loadcss';
import { Sentry } from "./sentryInstrument";

let canSeek = false;

function onPlayerReady(player, element) {
  // NOTE: window.STATIC_URL should be defined in base template.
  try {
    loadcss(window.STATIC_URL + 'plyr/dist/plyr.css');
  } catch(error) {
	if (Sentry && Sentry.captureException) {
	  Sentry.captureException(error);
	}
  }
}
function setCurrentTime(player, element) {
  const pId = player.media.dataset.id;
  const playstate = parseFloat(Cookies.get(`playstate-${pId}`));
  const startAt = parseFloat(player.elements.original.dataset.startAt);
  if (isFinite(startAt)) {
	if (element) {
	  element.currentTime = startAt;
	} else {
	  player.currentTime = startAt;
	}
  }
  if (canSeek && isFinite(playstate) && playstate > 0) {
	if (element) {
	  element.currentTime = playstate;
	} else {
      player.currentTime = playstate;
	}
    canSeek = false;
  }
  window.addEventListener("beforeunload", () => {
    Cookies.set(`playstate-${player.media.dataset.id}`, player.currentTime, { expires: 1200 });
  });
}
document.addEventListener("DOMContentLoaded", (event) => {
  // leave the eventhandler if no video files
  if (!document.querySelector('.video-player')) {
    return;
  }
  const player = new Plyr(".video-player");
  
  canSeek = true;
  const videoEl = player.media.querySelector("video");
  if (videoEl) {
	videoEl.addEventListener("loadstart", event => onPlayerReady(player, videoEl), {once: true});
	videoEl.addEventListener("playing", event => setCurrentTime(player, videoEl), {once: true});
  } else {
	player.on("ready", event => onPlayerReady(event.detail.plyr));
	player.once("playing", event => setCurrentTime(event.detail.plyr));
  }
});
